/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * How the value may be read back. Defaults to `writeonly`.
 *
 * @remarks
 */
export const Kind = {
  Recoverable: "recoverable",
  Writeonly: "writeonly",
} as const;
/**
 * How the value may be read back. Defaults to `writeonly`.
 *
 * @remarks
 */
export type Kind = ClosedEnum<typeof Kind>;

/**
 * A single environment variable to set.
 */
export type EnvironmentVariableInput = {
  /**
   * The variable name. Must be a POSIX shell name: letters, digits, and
   *
   * @remarks
   * underscores only, and must not start with a digit. Other names are
   * unreachable from shells and most runtimes.
   */
  key: string;
  /**
   * The variable value. Always encrypted at rest. The limit is enforced
   *
   * @remarks
   * server-side in UTF-8 bytes, so a multibyte value may be rejected before
   * it reaches this code-point maximum.
   */
  value: string;
  /**
   * How the value may be read back. Defaults to `writeonly`.
   *
   * @remarks
   */
  kind?: Kind | undefined;
  /**
   * Human-readable description of the variable.
   *
   * @remarks
   */
  description?: string | undefined;
};

/** @internal */
export const Kind$outboundSchema: z.ZodNativeEnum<typeof Kind> = z.nativeEnum(
  Kind,
);

/** @internal */
export type EnvironmentVariableInput$Outbound = {
  key: string;
  value: string;
  kind: string;
  description?: string | undefined;
};

/** @internal */
export const EnvironmentVariableInput$outboundSchema: z.ZodType<
  EnvironmentVariableInput$Outbound,
  z.ZodTypeDef,
  EnvironmentVariableInput
> = z.object({
  key: z.string(),
  value: z.string(),
  kind: Kind$outboundSchema.default("writeonly"),
  description: z.string().optional(),
});

export function environmentVariableInputToJSON(
  environmentVariableInput: EnvironmentVariableInput,
): string {
  return JSON.stringify(
    EnvironmentVariableInput$outboundSchema.parse(environmentVariableInput),
  );
}
